<template>
  <div
    v-if="value"
    class="alert"
    :class="error ? 'alert-danger' : 'alert-success'"
    role="alert"
  >
    {{ value }}
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: ""
    },
    error: {
      default: false
    }
  },
  watch: {
    value: {
      handler: function (val) {
        if (val) {
          setTimeout(() => {
            this.$emit("input", "");
          }, 2000);
        }
      },
      immediate: true
    }
  }
};
</script>

<style>
.alert {
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  position: fixed !important;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  padding: 0.75rem;
  text-align: center;
}
.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}
.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
</style>
